import API from '../../lib/api'
import base from './base'

const api = new API(1, 'age')
const baseModule = base(api);

// actions
const actions = {
	getList: baseModule.actions.getList,
	update: (context, obj) => {
		return new Promise((resolve, reject) => {
			return api.patch(obj.year, { colour: obj.colour }).then(res => {
				resolve(res)
				context.commit('update', obj)
			})
			.catch(err => {
				reject(err)
			})
		})
	},
}

baseModule.mutations.update = (state, obj) => {
	state.list.every((item, i) => {
		if(item.year === obj.year) {
			state.list.splice(i, 1, obj)
			return false
		}
		return true
	});
}

// mutations
const mutations = {
	setList: baseModule.mutations.setList,
	update: baseModule.mutations.update
}

export default {
	namespaced: true,
	state: baseModule.state,
	getters: baseModule.getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/age.js